import { Formik } from "formik";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import DataField from "../../atoms/dataField";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import ExtractorExplorer from "../extractorExplorer/ExtractorExplorer";
import React, { useEffect, useState } from "react";
import Typography from "@mui/material/Typography";
import { IFormDropDown, IFormField } from "../../shared/globalTypes";
import * as functions from "../../shared/functions";
import InputLabel from "@mui/material/InputLabel";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import * as constants from "../../../constants/_pickerValues";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { IAccessControl } from "../../../store/dataSource/types";
import { useDispatch, useSelector } from "react-redux";
import { getAccessControlPendingSelector, getAccessControlSelector } from "../../../store/dataSource/selectors";
import { IUser } from "../../../store/groups/types";
import IconButton from "@mui/material/IconButton";
import DeleteSharpIcon from "@mui/icons-material/DeleteSharp";
import { fetchGroupUsersRequest } from "../../../store/groups/actions";
import { fetchAccessControlRequest } from "../../../store/dataSource/actions";
import { getProfileDataSelector, getRoleClaimsSelector } from "../../../store/auth/selectors";
import { getGroupPendingSelector, getGroupUsersSelector } from "../../../store/groups/selectors";
import { IDP_USERS_PRODUCTION, UDL_HUB_SERVICE_PRINCIPALS } from "../../../constants/common";
import * as actions from "../../../store/requestOverride/actions";
import { getOverrideRequest } from "../../../store/requestOverride/actions";
import { useParams } from "react-router";
import { fetchOverrideRequestSelector } from "../../../store/requestOverride/selectors";
import OverrideRequestUpdateStatus from '../../molecules/overrideRequestUpdateStatus/OverrideRequestUpdateStatus'

interface Props {
    mode?: string;
}

export interface IOverrideRequestFields {
    owner: IFormField;
    sourceId: IFormField;
    tableId: IFormField;
    grantee: IFormField;
    granteeType: IFormField;
    status: IFormField;
    treatmentLevel: IFormField;
    businessReason: IFormField;
}

export interface IOverrideFields {
    owner: IFormField;
    sourceId: IFormField;
    tableId: IFormField;
    grantee: IFormField;
    granteeType: IFormField;
    treatmentLevel: IFormField;
    businessReason: IFormField;
}

export type granteeTypeList = {
    key: number;
    granteeType: string;
    grantee: string;
    isError: boolean;
};

export const granteeListInitialState = [
    {
        key: Date.now(),
        granteeType: "Individual",
        grantee: "",
        isError: false,
    }
];

let OverrideRequestInitialState: IOverrideRequestFields = {
    owner: { fieldValue: "", isError: false, errorMsg: "", isNumber: false },
    sourceId: { fieldValue: "", isError: false, errorMsg: "", isNumber: false },
    tableId: { fieldValue: "", isError: false, errorMsg: "", isNumber: false },
    grantee: { fieldValue: "", isError: false, errorMsg: "", isNumber: false },
    granteeType: {
        fieldValue: "",
        isError: false,
        errorMsg: "",
        isNumber: false,
    },
    status: { fieldValue: "", isError: false, errorMsg: "", isNumber: false },
    treatmentLevel: {
        fieldValue: "",
        isError: false,
        errorMsg: "",
        isNumber: false,
    },
    businessReason: { fieldValue: "", isError: false, errorMsg: "", isNumber: false },
};

const OverrideRequestForm = ({ mode = constants.MODE.add }: Props) => {

    const { requestId } = useParams();

    const accessControls = useSelector(getAccessControlSelector);
    const userProfile = useSelector(getProfileDataSelector);
    const idpUsersProduction = useSelector(getGroupUsersSelector(IDP_USERS_PRODUCTION));
    const idpUsersProductionPending = useSelector(getGroupPendingSelector(IDP_USERS_PRODUCTION));
    const udlHubServicePrincipals = useSelector(getGroupUsersSelector(UDL_HUB_SERVICE_PRINCIPALS));
    const udlHubServicePrincipalsPending = useSelector(getGroupPendingSelector(UDL_HUB_SERVICE_PRINCIPALS));
    const accessControlsPending = useSelector(getAccessControlPendingSelector);
    const roles = useSelector(getRoleClaimsSelector);
    //To Do
    const getOverride = useSelector(fetchOverrideRequestSelector);
    const dispatch = useDispatch();

    const [overrideRequestFormData, setOverrideRequestFormData] =
        useState(OverrideRequestInitialState);
    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const [tableError, setTableError] = useState(false);
    const [typeError, setTypeError] = useState(false);
    const [grantees, setGrantees] = useState<granteeTypeList[]>(
        mode === constants.MODE.add ? granteeListInitialState : []
    );
    const [overridesPrincipals, setOverridesPrincipals] = useState<IUser[]>([]);
    const [disableSaveBtn, setDisableSaveBtn] = useState(true);
    const [isAdmin, setIsAdmin] = useState(false);
    const [owner, setOwner] = useState("");
    const [createdBy, setCreatedBy] = useState('');
    const [createdOn, setCreatedOn] = useState('');
    const [updatedBy, setUpdatedBy] = useState('');
    const [updatedOn, setUpdatedOn] = useState('');
    const [isDataSteward, setIsDataSteward] = useState(false);
    const [isGrantee, setIsGrantee] = useState(false);
    const [requestStatus, setRequestStatus] = useState('');
    const [openDialog, setOpenDialog] = useState(false);
    const [statusDetailMsg, setStatusDetailMsg] = useState('');
    const [actionType, setActionType] = useState('');
    const [expiryDate, setExpiryDate] = useState('');
    const [dataSteward, setDataSteward] = useState('');
    const [disableButton, setDisableButton] = useState(false);

    const tableSelectorstyle = {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: 1300,
        background: "white",
        height: 700,
        p: 4,
        overflowY: "auto",
    };

    const buttonStyle = {
        bottom: "0%",
        left: "10%",
    };

    useEffect(() => {
        if (roles && roles.length > 0) {
            setIsAdmin(roles.includes("IDP.Admin"));
        }
    }, [roles]);

    useEffect(() => {
        setOverridesPrincipals(idpUsersProduction.concat(udlHubServicePrincipals))
    }, [idpUsersProduction, udlHubServicePrincipals]);

    useEffect(() => {
        if (mode !== constants.MODE.add && requestId) {
            dispatch(getOverrideRequest(requestId));
        }
    }, [requestId]);

    useEffect(() => {
        if (mode === constants.MODE.view && getOverride) {
            overrideRequestFormData.sourceId.fieldValue = getOverride["sourceId"];
            overrideRequestFormData.tableId.fieldValue = getOverride["tableId"];
            overrideRequestFormData.grantee.fieldValue = getOverride["grantee"];
            overrideRequestFormData.granteeType.fieldValue = getOverride["granteeType"];
            overrideRequestFormData.treatmentLevel.fieldValue = getOverride["treatmentLevel"];
            overrideRequestFormData.businessReason.fieldValue = getOverride["businessReason"] || "";
            overrideRequestFormData.status.fieldValue = functions.getRequestStatusText(getOverride["status"])!;
            setExpiryDate(getOverride["expiryDate"]);
            setDataSteward(getOverride["dataSteward"]);
            setRequestStatus(getOverride["status"]);
            setStatusDetailMsg(getOverride["statusDetailMessage"] || "");
            setOverrideRequestFormData(overrideRequestFormData);
            setCreatedBy(getOverride["createdBy"]);
            setCreatedOn(getOverride["createdOn"]);
            setUpdatedBy(getOverride["updatedBy"]);
            setUpdatedOn(getOverride["updatedOn"]);
            console.log(userProfile["userPrincipalName"], "userprincipalname");
            console.log(getOverride["dataSteward"], "datasteward");
            if (userProfile["userPrincipalName"].toLowerCase() === getOverride["dataSteward"].toLowerCase()) {
                setIsDataSteward(true);
            }
            if (userProfile["userPrincipalName"].toLowerCase() === getOverride["grantee"].toLowerCase()) {
                setIsGrantee(true);
            }
            setDisableButton(false);

        } else {
            overrideRequestFormData.owner.fieldValue = "";
            overrideRequestFormData.sourceId.fieldValue = "";
            overrideRequestFormData.tableId.fieldValue = "";
            overrideRequestFormData.grantee.fieldValue = "";
            overrideRequestFormData.treatmentLevel.fieldValue = "";
            overrideRequestFormData.businessReason.fieldValue = "";
            setOverrideRequestFormData(overrideRequestFormData);
        }
    }, [getOverride, mode]);

    useEffect(() => {
        window.scrollTo(0, 0)
        if (idpUsersProduction.length <= 0 && !idpUsersProductionPending) {
            dispatch(fetchGroupUsersRequest(IDP_USERS_PRODUCTION));
        }
        if (udlHubServicePrincipals.length <= 0 && !udlHubServicePrincipalsPending) {
            dispatch(fetchGroupUsersRequest(UDL_HUB_SERVICE_PRINCIPALS));
        }
        if (!accessControlsPending && accessControls.length <= 0) {
            dispatch(fetchAccessControlRequest());
        }
    });

    useEffect(() => {
        if (userProfile) {
            overrideRequestFormData.owner.fieldValue = userProfile["userPrincipalName"];
            setOverrideRequestFormData(overrideRequestFormData);
            setOwner(userProfile["userPrincipalName"]);
            if (!isAdmin && mode === constants.MODE.add && grantees.length > 0) {
                grantees[0].grantee = userProfile["userPrincipalName"];
            }
        }
    }, [userProfile]);

    const handleChange = (event: {}) => {
        const e = event as React.ChangeEvent<HTMLInputElement>;
        (e.target.value === "" || !e.target.value)
            ? setTableError(true)
            : setTableError(false);
        setOverrideRequestFormData({
            ...overrideRequestFormData,
            [e.target.name]: functions.getFormField(e.currentTarget.value),
        });
    };

    const onGranteeBlur = (event: {}) => {
        const e = event as React.FocusEvent<HTMLInputElement>;
        let value = grantees.find(
            (grantee) => grantee.key === parseInt(e.target.name)
        );
        (e.target.value === "" || !e.target.value)
            ? (value!.isError = true)
            : (value!.isError = false);
        setGrantees(grantees);
    };

    const onGranteeChange = (inputGrantee: granteeTypeList) => {
        const newGrantees = grantees.map((item) => {
            if (item.key === inputGrantee.key) return inputGrantee;
            return item;
        });
        setGrantees(newGrantees);
    };

    const onSelectTable = (tableId: string, sourceId: string, sourceName: string) => {
        overrideRequestFormData.sourceId.fieldValue = sourceName;
        overrideRequestFormData.tableId.fieldValue = tableId;
        setOverrideRequestFormData(overrideRequestFormData);
    };

    const onHandleBlur = (event: {}) => {
        const e = event as React.FocusEvent<HTMLInputElement>;
        (e.target.value === "" || !e.target.value)
            ? setTypeError(true)
            : setTypeError(false);
        setOverrideRequestFormData(overrideRequestFormData);
    };

    const addGrantee = () => {
        setGrantees(
            grantees.concat({
                key: Date.now(),
                granteeType: "",
                grantee: "",
                isError: false,
            })
        );
    };

    const deleteGrantee = (id: number) => {
        if (grantees.length > 1) {
            const granteeItem = grantees.filter((item) => item.key !== id);
            setGrantees(granteeItem);
        } else {
            alert("At least one Grantee is required to submit Role Override.");
        }
    };

    const goBack = () => {
        window.history.back();
    };

    const handleGranteeTypeChange = (event: SelectChangeEvent, key: number) => {
        onGranteeChange({
            key: key,
            granteeType: event.target.value,
            grantee: "",
            isError: false,
        });
    };

    const handleOverrideTypeChange = (e: SelectChangeEvent<string>) => {
        let field: IFormDropDown = {
            fieldValue: e.target.value,
            isError: false,
            errorMsg: "",
        };

        setOverrideRequestFormData({ ...overrideRequestFormData, [e.target.name]: field });
    };

    const approveConfirmDialog = () => {
        setActionType('approve');
        setOpenDialog(true);
    }

    const rejectConfirmationDialog = () => {
        setActionType('reject');
        setOpenDialog(true);
    }

    const cancelConfirmationDialog = () => {
        setActionType('cancel');
        setOpenDialog(true);
    }

    const skipConfirmationDialog = () => {
        setActionType('skip');
        setOpenDialog(true);
    }

    const retryConfirmationDialog = () => {
        setActionType('retry');
        setOpenDialog(true);
    }

    const handleCloseDialog = (refresh?: boolean) => {
        // TODO: use UseEffect instead to check for patch success before refreshing data?
        if (requestId && refresh === true) {
            setDisableButton(true);
            dispatch(getOverrideRequest(requestId));
        }
        setOpenDialog(false);
    }

    const validate = () => {
        overrideRequestFormData.owner.isError = overrideRequestFormData.owner.fieldValue === "";
        overrideRequestFormData.sourceId.isError =
            overrideRequestFormData.sourceId.fieldValue === "";
        overrideRequestFormData.tableId.isError =
            overrideRequestFormData.tableId.fieldValue === "";
        overrideRequestFormData.treatmentLevel.isError =
            overrideRequestFormData.treatmentLevel.fieldValue === "";
        overrideRequestFormData.businessReason.isError =
            overrideRequestFormData.businessReason.fieldValue === "";

        const validateKeys = [
            "owner",
            "sourceId",
            "tableId",
            "treatmentLevel",
            "businessReason",
        ];

        const data = Object.fromEntries(
            Object.entries(overrideRequestFormData).filter(([key]) =>
                validateKeys.includes(key)
            )
        );

        setOverrideRequestFormData(overrideRequestFormData);

        const granteesError = grantees.filter(
            (x) => x.isError || x.grantee === ""
        );

        const overrideFormDataError = Object.values(data as IOverrideFields).filter(
            (x: IFormField) => x.isError || x.fieldValue === ""
        );

        if (overrideFormDataError.length > 0 || granteesError.length > 0) {
            setDisableSaveBtn(true);
        } else {
            setDisableSaveBtn(false);
        }
    };

    useEffect(() => {
        validate();
    }, [overrideRequestFormData, grantees]);

    function createNewOverrideRequest() {
        if (mode === constants.MODE.add) {
            let payload = grantees.map(
                (item: granteeTypeList, index: number, items: granteeTypeList[]) => {
                    return {
                        sourceId: overrideRequestFormData.sourceId.fieldValue,
                        tableId: overrideRequestFormData.tableId.fieldValue,
                        grantee: item.grantee,
                        granteeType: item.granteeType,
                        treatmentLevel: overrideRequestFormData.treatmentLevel.fieldValue,
                        businessReason: overrideRequestFormData.businessReason.fieldValue
                    };
                }
            );

            dispatch(actions.postOverrideRequest(payload));
            setDisableSaveBtn(true);
        }
    }

    return (
        <Formik initialValues={{}} onSubmit={() => { }}>
            <div>
                <h1 style={{ textAlign: "left" }}>Request Override</h1>
                <div>
                    <Grid container spacing={4}>
                        <Grid item xs={8}>
                            {mode === constants.MODE.add ?
                                <>
                            <Box>
                                <DataField id="tableId"
                                    name="tableId"
                                    label="Select Table"
                                    required
                                    error={tableError}
                                    value={overrideRequestFormData.tableId.fieldValue}
                                    onChange={handleChange}
                                    onClick={handleOpen}
                                />
                            </Box>
                            <Modal
                                open={open}
                                onClose={handleClose}
                                aria-labelledby="modal-modal-title"
                                aria-describedby="modal-modal-description"
                                sx={{ overflowY: "auto" }}
                            >
                                <Box sx={tableSelectorstyle}>
                                    <ExtractorExplorer
                                        selectable={"single"}
                                        selectedValue={overrideRequestFormData.tableId.fieldValue}
                                        onSelect={onSelectTable}
                                        displayIcons={false}
                                        displayActionButtons={false}
                                        nonUdlTables={true}
                                    />
                                    <Typography
                                        id="modal-modal-description"
                                        sx={{ mt: 2, mb: 2 }}
                                    />
                                    <Box
                                        sx={buttonStyle}
                                        display="flex"
                                        justifyContent="flex-end"
                                    >
                                        <Button id="close"
                                            color="primary"
                                            variant="contained"
                                            onClick={handleClose}
                                        >
                                            Close
                                        </Button>
                                        <Button id="btnClose"
                                            color="primary"
                                            variant="contained"
                                            onClick={handleClose}
                                            sx={{ ml: 1 }}
                                        >
                                            Select
                                        </Button>
                                    </Box>
                                </Box>
                                    </Modal>
                                </> : (
                                    <DataField id="selectedTableId"
                                        name="tableId"
                                        label="Select Table"
                                        value={overrideRequestFormData.tableId.fieldValue}
                                        readOnly={true}
                                    />
                                )}
                        </Grid>
                        <Grid item xs={4}>
                            <FormControl fullWidth required>
                                <InputLabel id="override-type-label">Override Type</InputLabel>
                                <Select
                                    labelId="override-type-label"
                                    label="Override Type"
                                    name="treatmentLevel"
                                    required
                                    error={typeError}
                                    value={overrideRequestFormData.treatmentLevel.fieldValue}
                                    onBlur={onHandleBlur}
                                    disabled={mode === constants.MODE.view}
                                    inputProps={{
                                        readOnly: mode === constants.MODE.view,
                                    }}
                                    variant={
                                        mode === constants.MODE.view ? "standard" : "outlined"
                                    }
                                    onChange={handleOverrideTypeChange}
                                >
                                    <MenuItem value="medium">Medium Treatment</MenuItem>
                                    <MenuItem value="high">High Treatment</MenuItem>
                                    <MenuItem value="access">Access</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        {mode === constants.MODE.add ? (
                            <Grid item xs={12}>
                                {isAdmin ? <Box
                                    display="flex"
                                    justifyContent="flex-start"
                                    style={{ marginBottom: "1em" }}
                                >
                                    <Button id="btnAddGrantee"
                                        color="primary"
                                        variant="contained"
                                        onClick={addGrantee}
                                    >
                                        Add New Grantee
                                    </Button>
                                </Box> : <></>}
                                    <div>
                                        {grantees.map((grantee) => (
                                            <React.Fragment key={grantee.key}>
                                                <Box
                                                    sx={{
                                                        border: 1,
                                                        borderColor: "divider",
                                                        padding: 2,
                                                        width: "100%",
                                                        display: "block",
                                                    }}
                                                >
                                                    <Grid container spacing={5} alignItems="center">
                                                        <Grid item xs={3}>
                                                            <FormControl fullWidth required>
                                                                <InputLabel>Grantee Type</InputLabel>
                                                                <Select
                                                                    labelId="grantee-type-label"
                                                                    label="Grantee Type"
                                                                    value={isAdmin ? grantee.granteeType : "individual"}
                                                                    onChange={(event) =>
                                                                        handleGranteeTypeChange(event, grantee.key)
                                                                    }
                                                                    disabled={!isAdmin}
                                                                >
                                                                    <MenuItem value="individual">
                                                                        Individual
                                                                    </MenuItem>
                                                                    <MenuItem value="group">Group</MenuItem>
                                                                </Select>
                                                            </FormControl>
                                                        </Grid>
                                                        {grantee.granteeType === "group" ? (
                                                            <Grid item xs={4}>
                                                                <Box>
                                                                    <FormControl fullWidth >

                                                                        <InputLabel id="selectGroupLabel">
                                                                            Group
                                                                        </InputLabel>
                                                                        <Select
                                                                            name={grantee.key.toString()}
                                                                            id={grantee.key.toString()}
                                                                            value={grantee.grantee.toLowerCase()}
                                                                            label="Group"
                                                                            required
                                                                            onBlur={onGranteeBlur}
                                                                            error={grantee.isError}
                                                                            onChange={(event) =>
                                                                                onGranteeChange({
                                                                                    key: grantee.key,
                                                                                    granteeType: grantee.granteeType,
                                                                                    grantee: event.target.value,
                                                                                    isError: false,
                                                                                })
                                                                            }
                                                                            labelId="selectGroupLabel"
                                                                            fullWidth
                                                                            disabled={mode === constants.MODE.view}
                                                                            sx={{ textAlign: "left" }}
                                                                        >
                                                                            {accessControls.map(
                                                                                (
                                                                                    item: IAccessControl,
                                                                                    index: number,
                                                                                    items: IAccessControl[]
                                                                                ) => {
                                                                                    return (
                                                                                        <MenuItem
                                                                                            key={index}
                                                                                            value={item.groupName.toLowerCase()}
                                                                                        >
                                                                                            {item.groupName}
                                                                                        </MenuItem>
                                                                                    );
                                                                                }
                                                                            )}
                                                                        </Select>
                                                                    </FormControl>

                                                                </Box>
                                                            </Grid>
                                                        ) : (grantee.granteeType === "individual" || !isAdmin) ? (
                                                            <Grid item xs={4}>
                                                                <Box>
                                                                    <FormControl fullWidth >

                                                                        <Autocomplete
                                                                            options={overridesPrincipals}
                                                                            onSelect={onGranteeBlur}
                                                                            onChange={(event, value) => {
                                                                                let v = value as IUser;
                                                                                onGranteeChange({
                                                                                    key: grantee.key,
                                                                                    granteeType: grantee.granteeType,
                                                                                    grantee: v.userName,
                                                                                    isError: false,
                                                                                });
                                                                            }}
                                                                            getOptionLabel={(option) =>
                                                                                option === undefined
                                                                                    ? " "
                                                                                    : option.userName
                                                                            }
                                                                            isOptionEqualToValue={(option, value) =>
                                                                                option.userName === value.userName
                                                                            }
                                                                                value={isAdmin ? functions.getIUser(grantee.grantee) : functions.getIUser(
                                                                                    owner
                                                                                )}
                                                                                disabled={mode === constants.MODE.view || !isAdmin}
                                                                            renderInput={(params) => (
                                                                                <TextField
                                                                                    {...params}
                                                                                    name={grantee.key.toString()}
                                                                                    value={grantee.grantee}
                                                                                    required
                                                                                    label="Individual"
                                                                                    error={grantee.isError}
                                                                                />
                                                                            )}
                                                                        />
                                                                    </FormControl>
                                                                </Box>
                                                            </Grid>
                                                        ) : null}
                                                        {(grantee.granteeType === "individual" || !isAdmin) ? <></> : (<Grid item xs={1}>
                                                            <IconButton
                                                                color="primary"
                                                                aria-label="upload picture"
                                                                component="span"
                                                                onClick={() => deleteGrantee(grantee.key)}
                                                            >
                                                                <DeleteSharpIcon />
                                                            </IconButton>
                                                        </Grid>)
                                                        }
                                                    </Grid>
                                                </Box>
                                            </React.Fragment>
                                        ))}
                                </div>
                            </Grid>
                        ) : (
                            <>
                                <Grid item xs={4}>
                                    <DataField id="f5a76189-05dd-48fe-a14f-2da6fec67580"
                                        name="granteeType"
                                        label="Grantee Type"
                                        value={overrideRequestFormData.granteeType.fieldValue}
                                        readOnly={true}
                                    />
                                </Grid>
                                <Grid item xs={4}>
                                    <DataField id="0da67b4a-ac2d-4e69-aa51-5b8433bb2ce7"
                                        name="grantee"
                                        label="Grantee"
                                        value={overrideRequestFormData.grantee.fieldValue}
                                        readOnly={true}
                                    />
                                </Grid>
                            </>
                        )}
                        {mode === constants.MODE.view && (
                            <Grid item xs={4}>
                                <DataField id="status"
                                    name="status"
                                    label="Status"
                                    value={overrideRequestFormData.status.fieldValue}
                                    readOnly={true}
                                />
                            </Grid>

                        )}
                        <Grid item xs={12}>
                            <DataField id="54c8de96-c0f7-4753-84c0-2782f307dcab"
                                type="textarea"
                                name="businessReason"
                                label="Business Reason"
                                disabled={mode === constants.MODE.view}
                                multiline={true}
                                rows={3}
                                value={overrideRequestFormData.businessReason.fieldValue}
                                onChange={handleChange}
                                required={mode !== constants.MODE.view}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Box display="flex" justifyContent="flex-end" m={0}>
                                {mode !== constants.MODE.view && (
                                    <Button id="cancelbtn" color="primary" variant="contained" onClick={goBack}>
                                        Go Back
                                    </Button>
                                )}
                                &nbsp;
                                {mode !== constants.MODE.view && (
                                    <Button id="savebtn"
                                        color="primary"
                                        variant="contained"
                                        onClick={createNewOverrideRequest}
                                        disabled={disableSaveBtn}
                                    >
                                        Save
                                    </Button>
                                )}
                                &nbsp;
                            </Box>
                        </Grid>

                    </Grid>
                    {mode !== constants.MODE.add &&
                        <Grid item xs={12}>
                            <Box display="flex" justifyContent="flex-end" m={2} >
                                {(
                                    (isAdmin || isGrantee) 
                                    && requestStatus !== constants.REQUEST_STATUS_VALUES.cancelled 
                                    && requestStatus !== constants.REQUEST_STATUS_VALUES.completed 
                                    && requestStatus !== constants.REQUEST_STATUS_VALUES.rejected 
                                    && requestStatus !== constants.REQUEST_STATUS_VALUES.approved
                                ) && (
                                    <>
                                        <Button 
                                            id="cancelBtn" 
                                            color="primary" 
                                            variant="contained" 
                                            style={{ marginRight: "1em" }} 
                                            onClick={cancelConfirmationDialog}
                                            disabled={disableButton}
                                        >
                                            Cancel Request
                                        </Button>
                                    </>
                                )}
                                {((requestStatus === constants.REQUEST_STATUS_VALUES.awaiting_review && isAdmin) || (requestStatus === constants.REQUEST_STATUS_VALUES.awaiting_approval && (isAdmin || isDataSteward))) && (
                                    <>
                                        <Button
                                            id="approveBtn"
                                            color="primary"
                                            variant="contained"
                                            style={{ marginRight: "1em" }}
                                            onClick={approveConfirmDialog}
                                            disabled={disableButton}
                                        >
                                            Approve
                                        </Button>
                                        <Button 
                                            id="rejectBtn"
                                            color="primary"
                                            variant="contained"
                                            style={{ marginRight: "1em" }}
                                            onClick={rejectConfirmationDialog}
                                            disabled={disableButton}
                                        >
                                            Reject
                                        </Button>
                                    </>
                                )}
                                {isAdmin && ((requestStatus === constants.REQUEST_STATUS_VALUES.pending_notification) ||  (requestStatus === constants.REQUEST_STATUS_VALUES.pending_completion)) && (
                                    <>
                                        <Button
                                            id="retryBtn"
                                            color="primary"
                                            variant="contained"
                                            style={{ marginRight: "1em" }}
                                            onClick={retryConfirmationDialog}
                                            disabled={disableButton}
                                        >
                                            Retry Automation
                                        </Button>
                                        <Button
                                            id="skipBtn"
                                            color="primary"
                                            variant="contained"
                                            style={{ marginRight: "1em" }}
                                            onClick={skipConfirmationDialog}
                                            disabled={disableButton}
                                        >
                                            Skip Automation
                                        </Button>
                                    </>
                                )}
                            </Box>
                        </Grid>
                    }
                    {mode !== constants.MODE.add &&
                        <Grid container spacing={4}>
                            <Grid item xs={6}>
                                <Box display="flex" justifyContent="flex-start">
                                    Created By: {createdBy}
                                </Box>
                                <Box display="flex" justifyContent="flex-start">
                                    Created On: {createdOn}
                                </Box>
                            </Grid>
                            <Grid item xs={6} >
                                <Box display="flex" justifyContent="flex-end">
                                    Updated By: {updatedBy}
                                </Box>
                                <Box display="flex" justifyContent="flex-end">
                                    Updated On: {updatedOn}
                                </Box>
                            </Grid>
                        </Grid>
                    }
                    <OverrideRequestUpdateStatus 
                        isOpen={openDialog}
                        handleClose={handleCloseDialog}
                        tableId={overrideRequestFormData.tableId.fieldValue} 
                        grantee={overrideRequestFormData.grantee.fieldValue}
                        treatmentLevel={overrideRequestFormData.treatmentLevel.fieldValue}
                        requestId={requestId || ''}
                        requestStatus={overrideRequestFormData.status.fieldValue}
                        statusDetailMessage={statusDetailMsg}
                        expiryDate={expiryDate}
                        dataSteward={dataSteward}
                        updateActionType={actionType}
                        />
                </div>
            </div>
        </Formik>
    )
}

export default OverrideRequestForm;